import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { SITE } from "@/lib/site";

// EDITABLE legal text. Items in [brackets] must be completed with your business details.
const LegalPage = ({ title, path, description, sections }) => (
  <section className="container-x pb-24 pt-32 md:pt-40" data-testid={`legal-${path.slice(1)}`}>
    <Seo title={title} description={description} path={path} />
    <div className="max-w-3xl">
      <span className="eyebrow">Legal</span>
      <h1 className="heading-xl mt-6 text-ink">{title}</h1>
      <p className="mt-4 text-sm text-slate-500">Last updated: [date]</p>
      <div className="mt-12 space-y-10">
        {sections.map(([h, p]) => (
          <div key={h}>
            <h2 className="font-serif text-2xl text-ink md:text-3xl">{h}</h2>
            <p className="mt-3 leading-relaxed text-slate-600">{p}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const Privacy = () => (
  <LegalPage
    title="Privacy Policy"
    path="/privacy"
    description="How Alpha Transfer collects, uses and protects your personal data."
    sections={[
      ["Who we are", `Alpha Transfer, [legal business name], [address], Rhodes, Greece. Contact: ${SITE.email}.`],
      ["What we collect", "When you book or contact us we collect your name, email, phone number, travel details (pickup, drop-off, date, time, flight number, passengers) and any notes you share."],
      ["Why we use it", "Only to provide your transfer or tour, to contact you about it, and to meet our legal and accounting obligations. We never sell your data."],
      ["Payments", "Online payments are processed by Stripe. Your card details go directly to Stripe and are never stored on our servers."],
      ["Cookies", "We use essential cookies so the site works. With your consent we may use analytics cookies to understand how the site is used. You can change your choice by clearing your browser storage."],
      ["How long we keep it", "Booking records are kept for [X] years for accounting purposes, then deleted."],
      ["Your rights", `Under the GDPR you can ask to access, correct or delete your data at any time. Email ${SITE.email}.`],
    ]}
  />
);

export const Terms = () => (
  <LegalPage
    title="Terms & Conditions"
    path="/terms"
    description="Booking terms for Alpha Transfer private transfers and tours in Rhodes."
    sections={[
      ["Bookings", "A booking is confirmed once you receive our confirmation email. Please check that all details, especially dates, times and flight numbers, are correct."],
      ["Prices", "Prices are per vehicle, not per person, and include taxes. Quotes for unlisted destinations and tours are confirmed in writing before your trip."],
      ["Payment", "You may pay online by card when booking, or pay the driver in cash or by card on the day."],
      ["Waiting time & delays", "Flight tracking is included. Free waiting time is [60] minutes after landing for airport pickups and [15] minutes for other pickups."],
      ["Cancellations", "Free cancellation up to [24] hours before pickup. Later cancellations or no-shows may be charged [in full]. [Edit to match your policy.]"],
      ["Luggage & child seats", "Please tell us about oversized luggage in advance. Child seats are free and must be requested when booking."],
      ["Liability", "[Add your licence and insurance details.] We are not responsible for delays caused by circumstances beyond our control."],
    ]}
  />
);

export const NotFound = () => (
  <section className="container-x pb-24 pt-40" data-testid="not-found-page">
    <Seo title="Page not found" description="This page does not exist." noindex />
    <span className="eyebrow">404</span>
    <h1 className="heading-xl mt-6 text-ink">This road leads nowhere.</h1>
    <p className="lead mt-4">Let us take you somewhere beautiful instead.</p>
    <Link to="/" className="btn btn-gold mt-8" data-testid="not-found-home-button">Back to home</Link>
  </section>
);
